<form [formGroup]="form()" [class]="formClassName">
  <input
    [type]="type()"
    [formControlName]="controlName()"
    [class]="inputClassName()"
    [min]="min()"
    [max]="max()"
  />
</form>
